import React from "react";
import PropTypes from 'prop-types';
import classNames from "classnames";
import MaterialIcon from "shared/react_components/MaterialIcon";

import { explanationText, cancelIcon, itemText } from "calls/styles/CriteriaResultItem.module.scss";

const CriteriaResultItem = ({ condition, score, explanation, className }) => (
  <div className={classNames("d-flex flex-row justify-content-between align-items-center", className)}>
    <div>
      <div className={itemText}>{condition}</div>
      {explanation && (
        <div className={classNames("d-flex flex-row align-items-center", explanationText)}>
          <MaterialIcon name="cancel" className={cancelIcon} />
          <div>{explanation}</div>
        </div>
      )}
    </div>
    <div className={itemText}>{`${score} Points`}</div>
  </div>
);

CriteriaResultItem.propTypes = {
  condition: PropTypes.string.isRequired,
  score: PropTypes.number.isRequired,
  explanation: PropTypes.string,
  className: PropTypes.string
};

export default CriteriaResultItem;
